import * as React from 'react';
import { Footer as FooterComponent } from 'decentraland-ui/dist/components/Footer/Footer';
import { T } from '../../modules/translation/utils';
export default class Footer extends React.PureComponent {
    getTranslations = () => {
        if (!this.props.hasTranslations) {
            return undefined;
        }
        return {
            dropdown: {
                en: React.createElement(T, { id: "@dapps.footer.dropdown.en" }),
                es: React.createElement(T, { id: "@dapps.footer.dropdown.es" }),
                fr: React.createElement(T, { id: "@dapps.footer.dropdown.fr" }),
                ja: React.createElement(T, { id: "@dapps.footer.dropdown.ja" }),
                zh: React.createElement(T, { id: "@dapps.footer.dropdown.zh" }),
                ko: React.createElement(T, { id: "@dapps.footer.dropdown.ko" })
            },
            links: {
                home: React.createElement(T, { id: "@dapps.footer.links.home" }),
                privacy: React.createElement(T, { id: "@dapps.footer.links.privacy" }),
                terms: React.createElement(T, { id: "@dapps.footer.links.terms" }),
                content: React.createElement(T, { id: "@dapps.footer.links.content" }),
                ethics: React.createElement(T, { id: "@dapps.footer.links.ethics" })
            }
        };
    };
    handleChange = (_, { value }) => {
        const { locale, onChange } = this.props;
        if (value && value !== locale && onChange) {
            onChange(_, { value });
        }
    };
    render() {
        return (React.createElement(FooterComponent, { ...this.props, onChange: this.handleChange, i18n: this.getTranslations() }));
    }
}
//# sourceMappingURL=Footer.js.map